module.exports = __webpack_public_path__ + "img/3939784_0008-min.635866f2.jpg";